import React, { useEffect } from 'react';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { useAppContext } from '@context/AppContext';
import styles from './RequireAuth.module.scss';

const RequireAuth: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const { isAuthenticated, login, isLoading, user, getToken } = useKindeAuth();
  const { state, dispatch } = useAppContext();

  useEffect(() => {
    const syncUserAndToken = async () => {
      if (isAuthenticated && user) {
        if (typeof getToken === 'function') {
          const token = await getToken();
          if (token) {
            dispatch({ type: 'SET_TOKEN', payload: token });
          }
        }

        dispatch({
          type: 'SET_USER',
          payload: {
            id: user.id || '',
            given_name: user.given_name || '',
            family_name: user.family_name || '',
            email: user.email || '',
          },
        });
      } else {
        dispatch({ type: 'LOGOUT' });
      }
    };

    syncUserAndToken();
  }, [isAuthenticated, user, getToken, dispatch]);

  if (isLoading) {
    return <div className={styles.validateSession}>Validando sesión...</div>;
  }

  if (!isAuthenticated) {
    login();
    return <div className={styles.validateSession}>Redirigiendo al login...</div>;
  }

  if (!state.token) {
    return <div className={styles.validateSession}>Cargando sesión...</div>;
  }

  return children;
};

export default RequireAuth;